import type { MergeableModalTypeMap, MergeModalTypeInput } from '../types/modal';

const modalTypeMap: MergeableModalTypeMap = {
  modal: {
    visible: 'visible',
    onClose: 'onCancel',
  },
  drawer: {
    visible: 'visible',
    onClose: 'onClose',
  },
  popover: {
    visible: 'visible',
    onClose: 'onClose',
  },
};

/**
 * 获取 modal 类型映射表。
 * @returns 当前 modal 类型映射
 */
function getModalTypeMap(): MergeableModalTypeMap {
  return modalTypeMap;
}

/**
 * 合并自定义 modal 类型映射。
 * @param map - 待合并的部分映射（含 module augmentation 扩展类型）
 * @returns 合并后的完整映射
 */
function mergeModalType(map: MergeModalTypeInput): MergeableModalTypeMap {
  return Object.assign(modalTypeMap, map);
}

export {
  modalTypeMap,
  getModalTypeMap,
  mergeModalType,
};
